module.exports = __webpack_public_path__ + "static/media/scissor-and-comb.901a07c8.svg";